'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CLASS_NAME = 'octicon octicon-git-merge';

var GitMergeIcon = function (_Component) {
  _inherits(GitMergeIcon, _Component);

  function GitMergeIcon() {
    _classCallCheck(this, GitMergeIcon);

    return _possibleConstructorReturn(this, (GitMergeIcon.__proto__ || Object.getPrototypeOf(GitMergeIcon)).apply(this, arguments));
  }

  _createClass(GitMergeIcon, [{
    key: 'render',
    value: function render() {
      var defaults = {
        height: 16,
        width: 12,
        viewBox: '0 0 12 16',
        'aria-hidden': true
      };

      var _props = this.props,
          className = _props.className,
          size = _props.size;

      if (className) {
        className = CLASS_NAME + ' ' + className;
      } else {
        className = CLASS_NAME;
      }

      if (size === 'mega') {
        defaults.height *= 2;
        defaults.width *= 2;
      }

      return _react2.default.createElement(
        'svg',
        _extends({}, defaults, this.props, { className: className }),
        _react2.default.createElement('path', { fillRule: 'evenodd', d: 'M10 7c-.73 0-1.38.41-1.73 1.02V8C7.22 7.98 6 7.64 5.14 6.98c-.75-.58-1.5-1.61-1.89-2.44A1.993 1.993 0 0 0 2 .99C.89.99 0 1.89 0 3a2 2 0 0 0 1 1.72v6.56c-.59.35-1 .99-1 1.72 0 1.11.89 2 2 2a1.993 1.993 0 0 0 1-3.72V7.67c.67.7 1.44 1.27 2.3 1.69.86.42 2.03.63 2.97.64v-.02c.36.61 1 1.02 1.73 1.02 1.11 0 2-.89 2-2 0-1.11-.89-2-2-2zm-6.8 6c0 .66-.55 1.2-1.2 1.2-.65 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2zM2 4.2C1.34 4.2.8 3.65.8 3c0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2zm8 6c-.66 0-1.2-.55-1.2-1.2 0-.65.55-1.2 1.2-1.2.65 0 1.2.55 1.2 1.2 0 .65-.55 1.2-1.2 1.2z' })
      );
    }
  }]);

  return GitMergeIcon;
}(_react.Component);

GitMergeIcon.propTypes = {
  className: _propTypes2.default.string
};
exports.default = GitMergeIcon;
//# sourceMappingURL=git-merge.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-octicons/lib/git-merge.js
// module id = 159
// module chunks = 0